import { API_ENDPOINTS } from '../../../rest/utils/api-endpoints';
import { HttpClient } from '../../../rest/utils/http';

// post query
export const PostApplicationSubmit = async (body: any) => {
  return await HttpClient.post(`${API_ENDPOINTS.APPLICATION_APPLIED}`, body);
};
